export type AbrangenciaFeriado = 'NACIONAL' | 'ESTADUAL' | 'MUNICIPAL';

export type OrigemFeriado = 'NACIONAL' | 'MANUAL';

export interface Feriado {
  id: string;
  data: string;
  nome: string;
  abrangencia: AbrangenciaFeriado;
  uf: string | null;
  municipio: string | null;
  origem: OrigemFeriado;
}

export interface CalendarioAno {
  ano: number;
  feriados: Feriado[];
  criadoEm: string;
  atualizadoEm: string;
}

export interface CalendarioResumo {
  ano: number;
  totalFeriados: number;
  atualizadoEm: string;
}

export interface FeriadoInput {
  data: string;
  nome: string;
  abrangencia: AbrangenciaFeriado;
  uf?: string | null;
  municipio?: string | null;
}

export interface ResultadoCopia {
  calendario: CalendarioAno;
  copiados: number;
  ignorados: number;
}

export interface FeriadoNacionalPreview {
  data: string;
  nome: string;
  jaExiste: boolean;
}

export interface ResultadoImportacao {
  calendario: CalendarioAno;
  importados: number;
  ignorados: number;
}

export interface DiaPulado {
  data: string;
  motivo: 'WEEKEND' | 'HOLIDAY';
  nomeFeriado?: string;
}

export interface SimulacaoPrazoInput {
  dataInicial: string;
  diasUteis: number;
}

export interface SimulacaoPrazo {
  dataFinal: string | null;
  diasPulados: DiaPulado[];
  anoSemCalendario: number | null;
}

export const ABRANGENCIA_LABEL: Record<AbrangenciaFeriado, string> = {
  NACIONAL: 'Nacional',
  ESTADUAL: 'Estadual',
  MUNICIPAL: 'Municipal',
};

export type AcaoHistorico =
  | 'CRIAR_CALENDARIO'
  | 'ADICIONAR_FERIADO'
  | 'EDITAR_FERIADO'
  | 'REMOVER_FERIADO'
  | 'IMPORTAR_NACIONAIS'
  | 'COPIAR_FERIADOS';

export interface EventoHistorico {
  id: string;
  em: string;
  ano: number;
  autor: string;
  acao: AcaoHistorico;
  descricao: string;
}

export const ACAO_HISTORICO_LABEL: Record<AcaoHistorico, string> = {
  CRIAR_CALENDARIO: 'Calendário criado',
  ADICIONAR_FERIADO: 'Feriado adicionado',
  EDITAR_FERIADO: 'Feriado editado',
  REMOVER_FERIADO: 'Feriado removido',
  IMPORTAR_NACIONAIS: 'Nacionais importados',
  COPIAR_FERIADOS: 'Feriados copiados',
};
